/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ParticipantStatusDto } from '../models/ParticipantStatusDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class RemoteParticipantStatusControllerService {

    /**
     * Check status of a participant
     * @param name
     * @returns ParticipantStatusDto OK
     * @throws ApiError
     */
    public static getRemoteParticipantHealthStatus(
        name: string,
    ): CancelablePromise<ParticipantStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/remote-participants/{name}/status',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
